import {Component, OnInit} from '@angular/core';
import {VerityPriceModel} from '../../../utils/models/verity-price-model';
import {SelectionModel} from '@angular/cdk/collections';
import {DecimalPipe} from '@angular/common';
import {VeritiyPricesTableRowModel} from '../../models/verity-prices-table-row-model';
import {DefaultExporterComponent} from '../../../utils/components/export/DefaultExporterComponent';

@Component({
    selector: 'app-net-prices',
    templateUrl: './net-prices.component.html',
    styleUrls: ['./net-prices.component.css']
})
export class NetPricesComponent extends DefaultExporterComponent implements OnInit {

    selection = new SelectionModel<VerityPriceModel>(true, []);
    tableInput: VerityPriceModel[] = [];
    tableColumns: VeritiyPricesTableRowModel[] = [];

    private possibleColumns: VeritiyPricesTableRowModel[] = [
        new VeritiyPricesTableRowModel(1, 100, 'Country', 'Country_name', true, 'left', true),
        new VeritiyPricesTableRowModel(2, 100, 'Company', 'Manufacturer', true, 'left', true),
        new VeritiyPricesTableRowModel(3, 110, 'Likely Parallel Trade', 'parallel_trade', true, 'left', true),
        new VeritiyPricesTableRowModel(4, 100, 'Brand', 'International_Brand_Name', true, 'left', true),
        new VeritiyPricesTableRowModel(5, 100, 'INN', 'INN', true, 'left', true),
        new VeritiyPricesTableRowModel(6, 100, 'ATC', 'ATC', true, 'left', true),
        new VeritiyPricesTableRowModel(7, 100, 'Strength', 'Strength', true, 'left', true),
        new VeritiyPricesTableRowModel(8, 100, 'Form', 'Form', true, 'left', true),
        new VeritiyPricesTableRowModel(9, 100, 'Pack size', 'Package_size', true, 'center', true),
        new VeritiyPricesTableRowModel(10, 100, 'Package', 'Package_type', true, 'left', true),
        new VeritiyPricesTableRowModel(11, 120, 'SKU Details', 'SKU_detail', true, 'left'),
        new VeritiyPricesTableRowModel(12, 120, 'Currency', 'Loc_Currency', true, 'left'),
        new VeritiyPricesTableRowModel(13, 120, 'Ex-Factory list price', 'ExF_excl_VAT', true, 'right'),
        new VeritiyPricesTableRowModel(14, 120, 'Ex-Factory list price flag', 'ExF_excl_VAT_flag', true, 'right'),
        new VeritiyPricesTableRowModel(15, 150, 'Mandatory discount', 'Mandatory_discount', true, 'right'),
        new VeritiyPricesTableRowModel(16, 150, 'Public Ex-Factory net price', 'Net_ExFactory_price', true, 'right'),
        new VeritiyPricesTableRowModel(17, 150, 'Public Ex-Factory net price flag', 'Net_ExFactory_price_flag', true, 'right'),
        new VeritiyPricesTableRowModel(18, 150, 'Hospital price', 'Hospital_price', true, 'right'),
        new VeritiyPricesTableRowModel(19, 150, 'Hospital price flag', 'Hospital_price_flag', true, 'right'),
        new VeritiyPricesTableRowModel(20, 150, 'Tender discount', 'Tender_Discount', true, 'right'),
        new VeritiyPricesTableRowModel(21, 150, 'Tender Ex-Factory price', 'Tender_ExFactory_price', true, 'right'),
        new VeritiyPricesTableRowModel(22, 150, 'Tender Ex-Factory price flag', 'Tender_ExFactory_price_flag', true, 'right'),
        new VeritiyPricesTableRowModel(23, 150, 'Last found date', 'last_found_dttm', true, 'center'),
        new VeritiyPricesTableRowModel(30, 100, 'SKU_id', 'SKU_id', true, 'left'),
        new VeritiyPricesTableRowModel(31, 100, 'Loc_Product_cd', 'Loc_Product_cd', true, 'left'),
    ];

    constructor(private decimalPipe: DecimalPipe) {
        super();
    }

    ngOnInit() {
        this.fetchData();
    }

    private fetchData() {
        this.http.post('getnetprices/', {})
            .subscribe(netPrices => {
                this.tableColumns = this.buildTableColumns(netPrices['headers']);
                this.tableInput = JSON.parse(netPrices['data']);
                this.tableInput.forEach(row => {
                    row['Mandatory_discount'] = this.decimalPipe.transform((Number(row['Mandatory_discount']) * 100), '1.2-2');
                    row['Tender_Discount'] = this.decimalPipe.transform((Number(row['Tender_Discount']) * 100), '1.2-2');
                });
            });
    }

    private buildTableColumns(headers: string[]) {
        const shownTableColumns = [];

        headers.forEach(key => {
            const column = this.possibleColumns.find(row => row.key === key);
            if (column) {
                shownTableColumns.push(column);
            }
        });

        return shownTableColumns;
    }
}
